<template>
  <div>
    <v-select v-if="$can('MultiCompanies')"
      class="companies-list"
      v-model="selected"
      item-text="fantasyName"
      item-value="id"
      label="Administrando"
      return-object
      :items="companies"
      hide-details
      dark />
    <template v-else>
      <div class="companies-list name">Mensageria</div>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        items: ['Empresa X', 'Empresa Y']
      }
    },
    computed: {
      ...mapGetters({
        companies: 'companies/list',
        currentCompanyId: 'global/currentCompanyId'
      }),
      selected: {
        get: function () {
          return this.companies.find(({ id }) => id === this.currentCompanyId)
        },
        set: async function (newValue) {
          let a = await this.$store.dispatch('global/currentCompanyId', newValue.id)
          this.firebase.auth().currentUser.getIdToken(true)
          return a
        }
      }
    },
    beforeMount () {
      this.$store.dispatch('companies/getList')
    }
  }
</script>

<style lang="sass">
  .companies-list.v-input
    margin-top: 5px

    .v-input__slot
      width: 250px

  .companies-list.name
    color: #fff
    font-size: 20px
    font-weight: 500
    display: flex
    align-items: center
    height: inherit

</style>
